import useFilter from '@components/Items/utils/hooks/useFilter'
import _isEmpty from 'lodash/isEmpty'

const Clear = () => {
  const {
    conditionQuery,
    locationQuery,
    pickupDateQuery,
    endDateQuery,
    categoryJsonQuery,
    bidftaPlusQuery,
    pickupDaysQuery,
    numberOfUniqueBiddersQuery,
    clearQuery,
  } = useFilter()

  if (
    !(
      conditionQuery ||
      locationQuery ||
      pickupDateQuery ||
      endDateQuery ||
      bidftaPlusQuery ||
      pickupDaysQuery ||
      numberOfUniqueBiddersQuery ||
      !_isEmpty(categoryJsonQuery)
    )
  )
    return <></>
  return (
    <button
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        clearQuery()
      }}
      className="py-1 px-2"
    >
      <span className="font-bold text-xs text-[#DC3329] hover:text-red transition-colors duration-300">
        CLEAR FILTERS
      </span>
    </button>
  )
}

export default Clear
